/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddActivityResponseSubstitute
 */
export interface AddActivityResponseSubstitute {
    /**
     * 
     * @type {string}
     * @memberof AddActivityResponseSubstitute
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof AddActivityResponseSubstitute
     */
    message?: string;
}

export function AddActivityResponseSubstituteFromJSON(json: any): AddActivityResponseSubstitute {
    return AddActivityResponseSubstituteFromJSONTyped(json, false);
}

export function AddActivityResponseSubstituteFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddActivityResponseSubstitute {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': json['user'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function AddActivityResponseSubstituteToJSON(value?: AddActivityResponseSubstitute | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
        'message': value.message,
    };
}


